import React, { FC } from 'react';
import { Input } from 'antd';
import longdash from '~/constants/longdash';

type Props = {
  value?: string;
};

const ApplicationIdInput: FC<Props> = ({ value }) => {
  return <Input disabled value={value || longdash} />;
};

export default ApplicationIdInput;
